var React = require("react");

module.exports = function() {
	return (
		<div>
			<p>
				You can set up whitelisting to restrict incoming connections to this environment. Users accessing this
				environment from an unwhitelisted IP address will receive an error message, which is logged as a 403 Forbidden request in your server logs.
				Changes to the whitelist require a full deployment to take effect. For more information visit
				<a href="https://servicedesk.silverstripe.cloud/support/solutions/articles/75000012655-ip-whitelisting" target="_blank" rel="noopener noreferrer"> Whitelist documentation.</a>
			</p>
		</div>
	);
};
